// prettier-ignore
export const ruLocale = {
  "messages": {
    "ui": {
      "blockTunes": {
        "toggler": {
          "Click to tune": "Настроить блок",
          "or drag to move": "или перетащить"
        }
      },
      "toolbar": {
        "toolbox": {
          "Add": "Добавить блок",
          "Filter": "Фильтр"
        },
        "inline": {
          "Bold": "Жирный",
          "Italic": "Курсив",
          "Link": "Ссылка",
          "InlineCode": "Код в строке"
        }
      }
    },
    "toolNames": {
      "Text": "Текст",
      "Heading": "Заголовок",
      "List": "Список",
      "Unordered List": "Маркированный список",
      "Ordered List": "Нумерованный список",
      "Warning": "Предупреждение",
      "Checklist": "Чек-лист",
      "Quote": "Цитата",
      "Code": "Код",
      "Delimiter": "Разделитель",
      "Raw HTML": "HTML",
      "Table": "Таблица",
      "Link": "Ссылка",
      "Marker": "Маркер",
      "Bold": "Жирный",
      "Italic": "Курсив",
      "InlineCode": "Код в строке",
      "Image": "Изображение",
      "Embed": "Встраиваемый контент",
      "Personality": "Персона",
      "Attaches": "Вложения",
      "Underline": "Подчеркивание",
      "Strikethrough": "Зачеркнутый",
      "Alignment": "Выравнивание",
      "Text Color": "Цвет текста",
      "Background Color": "Цвет фона",
      "Convert to": "Преобразовать в"
    },
    "tools": {
      "header": {
        "Header": "Заголовок",
        "Convert to": "Преобразовать в",
        "Heading 1": "Заголовок 1",
        "Heading 2": "Заголовок 2",
        "Heading 3": "Заголовок 3",
        "Plain text": "Обычный текст"
      },
      "list": {
        "Unordered": "Маркированный список",
        "Ordered": "Нумерованный список",
        "Checklist": "Чек-лист",
        "Can't be empty": "Не может быть пустым",
        "Task": "Задача",
        "Checked": "Отмечено"
      },
      "image": {
        "Caption": "Подпись",
        "With border": "С рамкой",
        "Stretch image": "Растянуть",
        "With background": "С фоном",
        "Select an Image": "Выберите изображение",
        "Drop an image": "Перетащите изображение",
        "or click to browse": "или кликните для выбора"
      },
      "warning": {
        "Title": "Название",
        "Message": "Сообщение"
      },
      "code": {
        "Enter a code": "Введите код"
      },
      "link": {
        "Add a link": "Добавить ссылку",
        "Paste a link": "Вставьте ссылку",
        "Open in new tab": "Открыть в новой вкладке"
      },
      "embed": {
        "Paste a link": "Вставьте ссылку",
        "This content can't be displayed": "Контент не может быть отображен",
        "Embed code": "Код для вставки"
      },
      "table": {
        "Add column to left": "Добавить столбец слева",
        "Add column to right": "Добавить столбец справа",
        "Add row above": "Добавить строку выше",
        "Add row below": "Добавить строку ниже",
        "Delete column": "Удалить столбец",
        "Delete row": "Удалить строку",
        "With headings": "С заголовками",
        "Without headings": "Без заголовков",
        "Stretch":"Растянуть",
        "Collapse": "Сжать"
      },
      "quote": {
        "Align left": "По левому краю",
        "Align center": "По центру",
        "Align right": "По правому краю"
      },
      "attaches": {
        "Attach files": "Прикрепить файлы",
        "Drop files to upload": "Перетащите файлы для загрузки",
        "or browse": "или выберите"
      }
    },
    "blockTunes": {
      "delete": {
        "Delete": "Удалить"
      },
      "moveUp": {
        "Move up": "Вверх"
      },
      "moveDown": {
        "Move down": "Вниз"
      },
      "converter": {
        "Convert to": "Преобразовать в",
        "Text": "Текст",
        "Heading": "Заголовок",
        "List": "Список",
        "Ordered List": "Нумерованный список",
        "Unordered List": "Маркированный список",
        "Quote": "Цитата",
        "Code": "Код",
        "Table": "Таблица",
        "Warning": "Предупреждение",
        "Checklist": "Чеклист",
        "Delimiter": "Разделитель",
        "Raw HTML": "HTML",
        "Image": "Изображение",
        "Embed": "Встраиваемый контент"
      }
    }
  }
};
